import React, { Component } from 'react';
import { Table, Row, Col, InputNumber, Button, DatePicker, message, Spin, Input } from 'antd';
import moment from 'moment';
import { data3_2_1 } from './data';
import imgSave from "../../saveImg";
import Auth from "../../Auth";

const { MonthPicker } = DatePicker;

Number.prototype.toFixed = function (exponent) {
    if (this > 0) {
        return parseInt(this * Math.pow(10, exponent) + 0.5) / Math.pow(10, exponent);
    } else {
        return parseInt(this * Math.pow(10, exponent) - 0.5) / Math.pow(10, exponent);
    }
}

class index extends Component {
    constructor(props) {
        super(props);
        this.state = {
            date: moment().subtract(1, 'month').format('YYYY-MM'),
            data: [],
            loading: true,
            loadingSave: false,
            print: false
        }
    }


    componentDidMount() {
        this.getDateData(this.state.date);
        // this.computeNum(this.state.data)
    }



    computeNum = (data) => {
        const numConvert = (num = 0) => {
            num = Number(num || "0")
            return num
        };

        const totalName = ['Adjusted', 'Debit', 'Credit'];
        for (let i = 0; i < data.length; i++) {
            data[i].Current = totalName.reduce((a, b, index) => {
                a += numConvert(data[i][b]);
                return a
            }, 0);
            data[i].Current = numConvert(data[i].Current).toFixed(2);
        }

        this.setState({
            data
        });

    }
    onChange = (name, value, i) => {
        let data = this.state.data;
        data[i][name] = value;

        this.computeNum(data);
    }

    getDateData = (date) => {
        const dataBegin = JSON.stringify(data3_2_1);
        let data = JSON.parse(dataBegin);

        fetch(`/_9_1_all?year=${moment(date).format('YYYY')}&month=${moment(date).format('M')}`, { credentials: 'include' }).then(x => x.json()).then(x => {
            if (x.data.dataNow && x.data.dataNow.length > 0) {
                data = x.data.dataNow;
            }

            if (x.data.datalast && x.data.datalast.length > 0) {
                let datalast = x.data.datalast;
                data = data.map((v, i) => ({ ...v, Adjusted: datalast[i].Current || "0" }));
            }

            this.setState({ loading: false });
            this.computeNum(data);
        }).catch(err => {
            this.setState({ loading: false });
            console.error(err);
        })
    }

    onSave = () => {
        this.setState({ loadingSave: true });
        let date = this.state.date;
        if (!date) {
            message.error('请选择年份月份');
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            return
        }
        let year = moment(date).format("YYYY");
        let month = moment(date).format("M");
        let data = this.state.data.map(x => ({ ...x, year, month }));
        // if (!data.every(x => x.name)) {
        //     message.error('名称不能为空，请到3-1-1设置名称！');
        //     return
        // }
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify(data));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        }
        fetch('/add_9_1', headres).then(x => x.json()).then(x => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            if (x.status == 1) {
                message.success(x.msg);
                if (!data[0].id) {
                    this.getDateData(this.state.date);
                }
                return
            }
            message.error(x.msg);
        }).catch(err => {
            let timer = setTimeout(() => { this.setState({ loadingSave: false }); clearTimeout(timer) }, 1000)
            console.error(err);
            message.error('保存失败' + JSON.stringify(err));
        })
    }

    downloadSG = () => {

        this.setState({ print: true, loading: true }, () => {
            imgSave('table9_1', 1.5, '9.10', this.state.date).then(x => {
                if (x.status == 1) {
                    message.info('添加成功！');
                } else {
                    message.error('添加失败' + x.msg);
                }

                this.setState({
                    print: false,
                    loading: false
                });
            }).catch(err => {
                console.error(err);
                this.setState({
                    print: false,
                    loading: false
                });
            })

        });

    }

    render() {
        const data = this.state.data;
        const width = document.body.offsetWidth - 2150 > 300 ? document.body.offsetWidth - 2150 : 300;
        const columns = [{
            title: 'Account Name 账户名',
            dataIndex: 'name',
            key: 'name',
            align: "center",
            render: (text, record, index) => {
                return (
                    <div className={`table-padding `} style={{ textAlign: "left" }}>
                        {text}
                    </div>
                )
            }
        }, {
            title: <div>Adjusted Balance of Last Month <br />期初数</div>,
            dataIndex: 'Adjusted',
            key: 'Adjusted',
            align: "center",
            render: (text, record, index) => {
                return (
                    // <div className="table-padding table-color-number">
                    //     <InputNumber
                    //         formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    //         parser={value => value.replace(/\$\s?|(,*)/g, '')}
                    //         precision={2}
                    //         className="table_numInput"
                    //         defaultValue={Number(text || "0") || ''}
                    //         onBlur={(e) => {
                    //             let value = Number(e.target.value.replace(/,/g, '') || '0');
                    //             value = Number(value.toFixed(2));
                    //             this.onChange('Adjusted', value, index)
                    //         }}

                    //     />
                    // </div>
                    <div className={`table-padding `}>
                        {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </div>
                )
            }
        }, {
            title: <div>Debit <br />借记/本期增加</div>,
            dataIndex: 'Debit',
            key: 'Debit',
            align: "center",
            render: (text, record, index) => {
                return (
                    <div className="table-padding table-color-number">
                        <InputNumber
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            precision={2}
                            className="table_numInput"
                            defaultValue={Number(text || "0") || ''}
                            onBlur={(e) => {
                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                value = Number(value.toFixed(2));
                                this.onChange('Debit', value, index)
                            }}

                        />
                    </div>
                )
            }
        }, {
            title: <div>Credit <br />贷记/本期减少</div>,
            dataIndex: 'Credit',
            key: 'Credit',
            align: "center",
            render: (text, record, index) => {
                return (
                    <div className="table-padding table-color-number">
                        <InputNumber
                            formatter={value => `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                            parser={value => value.replace(/\$\s?|(,*)/g, '')}
                            precision={2}
                            className="table_numInput"
                            defaultValue={Number(text || "0") || ''}
                            onBlur={(e) => {
                                let value = Number(e.target.value.replace(/,/g, '') || '0');
                                value = Number(value.toFixed(2));
                                this.onChange('Credit', value, index)
                            }}

                        />
                    </div>
                )
            }
        }, {
            title: <div>Balance of Current Month <br />期末数</div>,
            dataIndex: 'Current',
            key: 'Current',
            align: "center",
            render: (text, record, index) => {
                return (
                    <div className={`table-padding `}>
                        {Number(text || "0").toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                    </div>
                )
            }
        }, {
            title: <div>GM/DOF Comments <br /> 财务总监备注</div>,
            dataIndex: 'Comments',
            key: 'Comments',
            align: "center",
            render: (text, record, index) => {
                return (
                    <div className="table-padding table-color-number">
                        <Input
                            className="table_numInput"
                            defaultValue={text}
                            onBlur={(e) => {
                                let value = e.target.value || "";
                                this.onChange('Comments', value, index)
                            }}

                        />
                    </div>
                )
            }
        }];

        return (
            <Spin spinning={this.state.loading}>
                <div className="table7_1_1" >
                    <Row className="title" id="table9_1">
                        <Row>9.1 Balance Sheet 资产负债表</Row>
                        <Row className="table-month">
                            <MonthPicker
                                placeholder="请选择年月"
                                monthCellContentRender={(date, local) => {
                                    return moment(date).format('M月')
                                }}
                                defaultValue={moment(this.state.date, "YYYY-MM")}
                                format="YYYY-MM"
                                onChange={(date, str) => {
                                    this.setState({
                                        date: str,
                                        data: [],
                                        loading: true
                                    });
                                    this.getDateData(str)
                                }}
                            />
                        </Row>
                        <Table
                            columns={columns}
                            dataSource={data}
                            size="middle"
                            bordered
                            pagination={false}
                            className="content"
                            rowKey={(record, index) => index}
                        />
                    </Row>
                    <Auth loading={this.state.loading} auth="edit_9_1">
                        <Row className="table-footer-btn">
                            <Button
                                type="primary"
                                style={{ marginRight: 10 }}
                                onClick={this.downloadSG}
                                loading={this.state.print}
                            >加入PDF</Button>
                            <Button
                                type="primary"
                                onClick={this.onSave}
                                loading={this.state.loadingSave}
                            >保存</Button>
                        </Row>
                    </Auth>

                </div>
            </Spin >
        );
    }
}

export default index;


// WEBPACK FOOTER //
// ./src/components/table/9.0/9-1/index.js